export const teamMembers = [
  {
    name: '约会大师',
    role: '创始人 & 首席内容官',
    description: '拥有十年以上的社交经验，帮助超过万人提升约会能力。坚信每个人都有权利享受愉快的社交生活。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20confident%20mature%20man%20in%20a%20modern%20office%20setting%20warm%20lighting%20professional%20yet%20approachable%20editorial%20portrait%20photography%20beige%20tones%20high%20detail%20trustworthy%20expression&width=400&height=400&seq=team-yuehui-dashi&orientation=squarish',
  },
  {
    name: '沟通专家老张',
    role: '首席沟通顾问',
    description: '资深心理咨询师，专注于人际沟通与关系建设。为平台提供专业的沟通技巧和心理学指导。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20thoughtful%20middle%20aged%20man%20with%20glasses%20in%20a%20warm%20study%20room%20soft%20lighting%20intellectual%20and%20approachable%20editorial%20portrait%20photography%20beige%20tones%20high%20detail%20wise%20expression&width=400&height=400&seq=team-laozhang&orientation=squarish',
  },
  {
    name: '安全顾问小陈',
    role: '安全与健康顾问',
    description: '公共卫生领域专家，致力于推广安全约会理念。为平台提供约会安全与性健康方面的专业指导。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20professional%20woman%20in%20a%20clean%20modern%20office%20warm%20lighting%20competent%20and%20caring%20editorial%20portrait%20photography%20beige%20tones%20high%20detail%20reassuring%20expression&width=400&height=400&seq=team-xiaochen&orientation=squarish',
  },
];